export function onlyValidNumbers(input: any): any {
  return input.replace(/[^0-9-.]/g, '');
}
